export default "__VITE_ASSET__B3Ju2pxO__"